import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';
import { VerifyOtpRequest } from '../client-sdk/api';

export const useResetPasswordApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createResetPassword = useCallback(
    async (data: VerifyOtpRequest) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.verifyOtp(data);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  return {
    createResetPassword,

    loading,
    error,
  };
};
